import StoreButtons from "./StoreButtons";
import PhoneMockup from "./PhoneMockup";

export default function Hero({ highlight }) {
  return (
    <section className="hero" id="top" data-testid="hero-section">
      <div className="hero-bg" aria-hidden="true" />
      <div className="container hero-inner">
        <div className="hero-copy">
          <span className="hero-pill" data-testid="hero-pill">
            <span className="pill-dot" /> Hecho para Uruguay
          </span>
          <h1 className="hero-title">
            <span className="accent">LleGO</span> — Planificá tu viaje eléctrico en Uruguay
          </h1>
          <p className="hero-subtitle">
            Calculá si llegás, encontrá cargadores UTE/Mové/eOne en vivo y compará
            costo eléctrico vs nafta. Todo desde el celu.
          </p>
          <StoreButtons highlight={highlight} idPrefix="hero" />
          <p className="hero-micro">Gratis · iOS y Android</p>
        </div>
        <div className="hero-visual">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}
